import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class PostDeliveryActivities extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'postDeliveryActivities'}
            title={ t('support.procedure.P12.title') }
            exportTitle={ t('support.procedure.P12.exportTitle') }
            exportFileName={'postDeliveryActivities.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (PostDeliveryActivities);
